export const DOCUMENT_IDS = {
  RECEIPT: 'receipt',
  GOOD_FAITH_ESTIMATE: 'good-faith-estimate',
  GFE_PAYMENT_OPTIONS: 'gfe-payment-options',
  INVOICE: 'invoice',
  DR_CLEAR_CARE: 'dr-clear-care'
};

export const DOCUMENTS = [
  {
    id: DOCUMENT_IDS.RECEIPT,
    name: 'Payment receipt',
    icon: 'receipt-1-filled'
  },
  {
    id: DOCUMENT_IDS.GOOD_FAITH_ESTIMATE,
    name: 'Good Faith Estimate',
    icon: 'shield-tick-filled'
  },
  {
    id: DOCUMENT_IDS.GFE_PAYMENT_OPTIONS,
    name: 'GFE + payment option + insurance opt in / out',
    icon: 'receipt-1-filled'
  },
  {
    id: DOCUMENT_IDS.INVOICE,
    name: 'Invoice',
    icon: 'file-invoice-filled'
  },
  {
    id: DOCUMENT_IDS.DR_CLEAR_CARE,
    name: 'Dr.ClearCare full guide',
    icon: 'ai-summary-filled'
  }
];

const CARD_TRANSACTION_TYPES = [
  'card',
  'ONLINE',
  'COF',
  'SWIPE',
  'TOKEN',
  'CARD_PRESENT',
  'EMV_CONTACT',
  'EMV_PROXIMITY',
  'KIOSK_CARD_PRESENT'
];

export const receiptDocumentName = (transaction) =>
  CARD_TRANSACTION_TYPES.includes(transaction?.type) ? 'Credit card receipt' : 'Payment receipt';

export const INVOICE_DOCUMENT_PREFIX = 'invoice:';

export const invoiceDocumentId = (id) => `${INVOICE_DOCUMENT_PREFIX}${id}`;

export const invoiceIdFromDocumentId = (documentId) =>
  typeof documentId === 'string' && documentId.startsWith(INVOICE_DOCUMENT_PREFIX)
    ? documentId.slice(INVOICE_DOCUMENT_PREFIX.length)
    : null;

export const SUMMARY_BADGES = [
  { id: 'hipaa', icon: 'hipaa-secure-mono', text: 'HIPAA Secure' },
  { id: 'pci', icon: 'shield-mono', text: 'PCI - DSS' },
  { id: 'p2p', icon: 'lock-2-mono', text: 'P2P Encryption' },
  { id: 'onc', icon: 'specialty-award-mono', text: 'ONC-Certified' },
  { id: 'card-brand', icon: 'security-card-mono', text: 'Card-Brand Compliant Rider' }
];

export const SUMMARY_PANEL_BREAKPOINT = 900;
